import { Flex, Typography } from '@iheartjane/reefer';
import { clsx } from 'clsx';

import type { WizardStepProps } from '../../../utils/wizard/types';
import { WizardStepKey } from '../../../utils/wizard/types';

import tileStyles from '../wizardOptionTile.module.css';
import stepStyles from '../wizardStep.module.css';
import styles from './priceStep.module.css';

interface PriceOption {
  label: string;
  symbol?: string;
  value: string;
}

const PRICE_OPTIONS: PriceOption[] = [
  { label: 'Under $20', symbol: '$', value: ':19.99' },
  { label: '$20–40', symbol: '$$', value: '20:39.99' },
  { label: '$40–60', symbol: '$$$', value: '40:59.99' },
  { label: '$60–80', symbol: '$$$$', value: '60:79.99' },
  { label: '$80 and above', symbol: '$$$$$', value: '80:' },
  { label: 'No preference', value: '' },
];

interface PriceOptionTileProps {
  label: string;
  onClick: () => void;
  selected: boolean;
  symbol?: string;
}

function PriceOptionTile({
  label,
  onClick,
  selected,
  symbol,
}: PriceOptionTileProps) {
  const className = clsx(
    tileStyles['tile'],
    stepStyles['option'],
    styles['option'],
    selected && tileStyles['selected']
  );

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      aria-pressed={selected}
    >
      {symbol && <Typography variant="body-bold">{symbol}</Typography>}
      <Typography variant="body-bold">{label}</Typography>
    </button>
  );
}

export function PriceStep({ form, updateForm }: WizardStepProps) {
  const selections = form[WizardStepKey.Price];

  const handleSelect = (value: string) => {
    const isSelected = selections.includes(value);
    updateForm({
      ...form,
      [WizardStepKey.Price]: isSelected ? [] : [value],
    });
  };

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      gap={32}
      width="100%"
      height="100%"
      className={styles['priceFlex']}
    >
      <Flex flexDirection="column" alignItems="center" gap={8}>
        <Typography variant="header-bold" textAlign="center">
          What&apos;s your budget?
        </Typography>
        <Typography variant="body" textAlign="center">
          Per item. Pick one.
        </Typography>
      </Flex>

      <div className={clsx(stepStyles['grid'], styles['grid'])}>
        {PRICE_OPTIONS.map(({ label, symbol, value }) => {
          const selected = selections.includes(value);

          return (
            <PriceOptionTile
              key={value}
              label={label}
              onClick={() => handleSelect(value)}
              selected={selected}
              symbol={symbol}
            />
          );
        })}
      </div>
    </Flex>
  );
}
